import { DiscussionStoryDetailsMeta, DiscussionStoryDetailsPayload } from 'types/store/DiscussionStoryDetails';
import { createAsyncReducer } from 'utils/Redux';

import { discussionStoryDetailsActions } from '../actions';

export default createAsyncReducer<DiscussionStoryDetailsMeta, DiscussionStoryDetailsPayload>(discussionStoryDetailsActions);
